// External Plugins

// App components
// import './components/fixedHeader';
import './components/offCanvasNav';
import './components/cookieConsent';
import './components/fontTrackingCode';
import './components/quotationForm';
import './components/tabs';
import './components/faqs';
import { initLightboxGallery } from './components/lightboxGallery';

// IE11 polyfill for external svgs
import svg4everybody from 'svg4everybody';

(function() {
	const bindEvents = () => {
		// Remove o-ratio loader
		document.addEventListener('lazyloaded', e => {
			const closestHasLoaderParent = e.target.closest('.has-loader');

			if (closestHasLoaderParent) {
				closestHasLoaderParent.classList.remove('has-loader');
			}
		});
	};

	const init = () => {
		bindEvents();

		svg4everybody();

		// Init Photoswipe
		if (document.querySelectorAll('.gallery').length) {
			initLightboxGallery('.gallery');
		}
		if (document.querySelectorAll('figure.wp-caption').length) {
			initLightboxGallery('figure.wp-caption');
		}
	};

	document.addEventListener('DOMContentLoaded', init);
})();
